<template>
  <div>
    <!-- Bottom menu -->
    <v-bottom-navigation
      class="align-center"
      dark
      fixed
      z-index="4"
      grow
      dir="rtl"
    >
      <v-btn
        text
        color="success"
        v-for="(item, i) in listItems"
        :key="i"
        :to="{ name: item.name, params: { name: customers.url } }"
        :target="item.name == 'order' ? '_blank' : ''"
        :exact="true"
      >
        <span class="my-1">{{ item.title }}</span>

        <v-icon class="my-1" dense>{{ item.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "Botnavigation",

  data() {
    return {
      // Items of my menu
      listItems: [
        {
          id: 1,
          icon: "mdi-home",
          title: "خانه",
          name: "home",
        },
        {
          id: 2,
          icon: "mdi-cable-data",
          title: "تماس با ما",
          name: "aboutus",
        },
        {
          id: 3,
          icon: "mdi-clipboard-list-outline",
          title: "ثبت سفارش",
          name: "order",
        },
        // {
        //   id: 4,
        //   icon: "mdi-cog",
        //   title: "امکانات",
        //   name: "feature",
        // },
        {
          id: 5,
          icon: "mdi-image-album",
          title: "گالری",
          name: "gallery",
        },
        {
          id: 6,
          icon: "mdi-book-open-page-variant-outline",
          title: "کاتالوگ",
          name: "catalog",
        },
        {
          id: 7,
          icon: "mdi-panorama-variant-outline",
          title: "تور مجازی",
          name: "virtual_tour",
        },
        // {
        //   id: 5,
        //   icon: "mdi-comment-processing-outline",
        //   title: "نظرات و پیشنهادات",
        //   name: "comments",
        // },
      ],
      // booths: [],
      value: 1,
    };
  },
  props: { customers: {} },
  created() {},
  methods: {
    // async getBooth() {
    //   let response = await this.axios
    //     .get("https://namya.ir/api/v1/businesses/booths/48")
    //     .then((response) => {
    //       this.booths = response.data.data;
    //     })
    //     .catch((error) => {});
    // },
  },
};
</script>

<style>
@media only screen and (max-width: 769px) {
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 55px !important;
  }
}

@media only screen and (max-width: 320px) {
  .v-btn:not(.v-btn--round).v-size--default {
    min-width: 45px !important;
  }
}
</style>

<style scoped>
.theme--dark.v-bottom-navigation {
  background-color: #2b2e33;
}

.v-bottom-navigation {
  height: 60px !important;
}

.v-item-group.v-bottom-navigation {
  box-shadow: none;
}

.v-btn:not(.v-btn--round).v-size--default {
  height: inherit;
}

.theme--dark.v-btn.v-btn--has-bg {
  background-color: #2b2e33;
}

.theme--dark.v-bottom-navigation .v-btn:not(.v-btn--active) {
  color: inherit !important;
}

.v-item-group.v-bottom-navigation .v-btn .v-btn__content > *:not(.v-icon) {
  letter-spacing: 0rem !important;
}
</style>
